<template>
  <div
    class="d-flex flex-row-reverse"
  >
    <button
      class="focus-style"
      type="button"
      @click="removeRule()"
    >
      X
    </button>
  </div>
</template>

<script>
export default {
  name: 'RuleRemove',
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
  },
  methods: {
    removeRule () {
      this.$root.$emit('RemoveRule', [this.ruleReference])
    },
  },
}
</script>

<style lang="scss" scoped>
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
</style>
